import { render, staticRenderFns } from "./assist-legal-wait-distribution.vue?vue&type=template&id=75750272"
import script from "./assist-legal-wait-distribution.vue?vue&type=script&lang=ts"
export * from "./assist-legal-wait-distribution.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports